import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiCallStarted } from "../middleware/api";
import AdminService from "src/_services/AdminService";

export const getWaitingCount = createAsyncThunk(
  'admins/getWaitingCount',
  async () => {
      const response = await AdminService.getWaitingCount();
      return response.data.body;
  }
);

const slice = createSlice({
  name: "admins",
  initialState: {
    list: [],
    adminDetails: {},
    loading: false,
    lastFetch: null,
    rowCount: 0,
    pageSize: 0,
    page: 0,
    waitingCount: 0,
    waitingCountPending: false
  },
  reducers: {
    adminsRequested: (admins, action) => {
      admins.loading = true;
    },
    adminsRequestSucceeded: (admins, action) => {
      const { docs, totalDocs, limit, page } = action.payload.body;
      if (page && page > admins.page) {
        admins.list = [...admins.list, ...docs];
        admins.page = page;
        admins.rowCount = totalDocs;
        admins.pageSize = limit;
      } else {
        // TODO: to be removed when pagination implemented in loadadminsByTypeAndZone
        admins.list = docs;
        admins.page = 1;
        admins.rowCount = docs.length;
        admins.pageSize = docs.length;
      }
      admins.loading = false;
      admins.lastFetch = Date.now();
    },
    adminsRequestFailed: (admins, _) => {
      admins.loading = false;
    },
    adminDetailsRequestSucceded: (admins, action) => {
      admins.adminDetails = action.payload.body;
    },
    adminAdded: (admins, action) => {
      admins.list.push(action.payload);
    },
    adminRemoved: (admins, action) => {
      const index = admins.list.findIndex(
        (admin) => admin.id === action.payload.id
      );
      admins.list.splice(index, 1);
    },
    pageChanged: (admins, action) => {
      const { page: targetPage } = action.payload;
      admins.page = targetPage;
    },
    clearAdmins: (admins, action) => {
      admins.list = [];
      admins.page = 0;
      admins.rowCount = 0;
      admins.pageSize = 0;
      admins.lastFetch = null;
      admins.loading = false;
    },
    clearAdminDetails: (admins, action) => {
      admins.adminDetails = {};
    }
  },
  extraReducers: {
    [getWaitingCount.pending]: (state) => {
      state.waitingCountPending = true
    },
    [getWaitingCount.fulfilled]: (state, { payload }) => {
      state.waitingCount = payload
      state.waitingCountPending = false
    },
    [getWaitingCount.rejected]: (state) => {
      state.waitingCountPending = false
    },
  }
});

export const {
  adminsRequested,
  adminsRequestSucceeded,
  adminsRequestFailed,
  adminDetailsRequestSucceded,
  adminAdded,
  adminRemoved,
  pageChanged,
  clearAdmins,
  clearAdminDetails
} = slice.actions;

// Action Creators
const url = "/v1/admin-panel/admin";

export const loadAdmins = (page) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${url}?page=${page}`,
      onStart: adminsRequested.type,
      onSuccess: adminsRequestSucceeded.type,
      onError: adminsRequestFailed.type,
    })
  );
};

export const loadAdminDetails = (id) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${url}/${id}`,
      // onStart: adminsRequested.type,
      onSuccess: adminDetailsRequestSucceded.type,
      // onError: adminsRequestFailed.type,
    })
  );
};

export default slice.reducer;
